import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader from "../../components/layout/LayoutWrapper/PageHeader";
import userImg from "../../assets/userImg.png";
import Text from "../../components/typography/Text";
import Grid from "../../components/layout/grid/Grid";
import CustomButton from "../../components/common/CustomButton/CustomButton";
import CustomTextInputBasic from "../../components/common/CustomTextInput/CustomTextInputBasic";
import CustomSelectBasic from "../../components/common/CustomSelect/CustomSelectBasic";
import ResubmissionModal from "./ResubmissionModal";
import {
  advisorApprovalFn,
  advisorReSubmitFn,
  getadvisorDetailsFn,
} from "../../Services/advisorService";
import { successToast } from "../../utils/toasts";
import ShowFileOnUrlWithButton from "../../components/ShowFileOnUrlWithButton";

const AdvisorDetailPage = () => {
  const [reasonType, setReasonType] = useState([]);
  const [reason, setReason] = useState("");
  const [isReject, setIsReject] = useState(false);
  const [isRejectionEnabled, setIsRejectionEnabled] = useState(false);
  const [isActionDisabled, setIsActionDisabled] = useState(false);
  const [advisorData, setAdvisorData] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();
  const advisorlocalData = location?.state?.advisorData;
  console.log("advisorlocalData", advisorlocalData);

  useEffect(() => {
    getAdvisorInfoFn();
  }, []);

  const getAdvisorInfoFn = async () => {
    const data = await getadvisorDetailsFn(advisorlocalData?.advisor_id);
    setAdvisorData(data?.data);

    if (data?.data?.rejection_remark != null) {
      setIsRejectionEnabled(true);
      setIsActionDisabled(true);
      setReasonType(data?.data?.rejection_remark[0]?.reason_type);
      setReason(data?.data?.rejection_remark[0]?.reason);
    }

    // if status is Re-Submitted, override defaults
    if (advisorlocalData?.advisor_onboarding_status === "Re-Submitted") {
      setIsActionDisabled(false);
      setIsRejectionEnabled(false);
    }
  };
  const statusStyles = {
    Rejected: "bg-red-100 text-red-600 px-2 py-1 rounded-md",
    Pending: "bg-yellow-100 text-yellow-600 px-2 py-1 rounded-md",
    "Re-Submitted": "bg-blue-100 text-blue-600 px-2 py-1 rounded-md",
    Approved: "bg-green-100 text-green-600 px-2 py-1 rounded-md",
  };



  return (
    <div className="flex flex-col h-[calc(100vh-64px)] overflow-y-scroll p-4">
      <PageHeader title="Advisor Detail" showBack={true} />
      <div className="flex flex-col p-4 mb-2 bg-white border border-gray-200 rounded-md mt-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <img
              src={userImg}
              alt="Advisor"
              className="w-12 h-12 rounded-full object-scale-down bg-[#8080801c]"
            />
            <div>
              <Text className="!font-bold ml-2">{advisorlocalData.name}</Text>
              <Text className="!font-bold ml-2">#{advisorlocalData.advisor_display_id}</Text>
            </div>
          </div>
          <div
            className={`${statusStyles[advisorlocalData?.advisor_onboarding_status] ||
              "bg-gray-100 text-gray-600"
              } px-2 py-1 rounded-md`}
          >
            {advisorlocalData?.advisor_onboarding_status}
          </div>
        </div>

        <div className="flex justify-between items-center mt-2">
          <div className="w-1/3">
            <span className="text-sm font-medium text-gray-400">
              Joined As:
            </span>{" "}
            <span className="text-sm font-semibold ml-1">
              {advisorlocalData.join_as}
            </span>
          </div>
          <div className="w-1/3">
            <span className="text-sm font-medium text-gray-400">
              Mobile No:
            </span>{" "}
            <span className="text-sm font-semibold ml-1">
              {advisorlocalData.mobile_number}
            </span>
          </div>
          <div className="w-1/3">
            <span className="text-sm font-medium text-gray-400">Email:</span>{" "}
            <span className="text-sm font-semibold ml-1">
              {advisorlocalData.email || "abc@g.com"}
            </span>
          </div>
        </div>
      </div>

      {/* Personal & Bank Details */}
      <div className="flex flex-col p-4 bg-white border border-gray-200 rounded-md mt-4">
        <Text className="!font-bold mb-2">Personal Details</Text>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="name"
              label="Name"
              value={advisorData?.name}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="email"
              label="Email"
              value={advisorData?.email}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="mobile"
              label="Mobile"
              value={advisorData?.mobile_number}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="qualification"
              label="Qualification"
              value={advisorData?.qualification}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="aadharCard"
              label="Aadhar Card"
              value={advisorData?.aadhar_card_number}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="panCard"
              label="PAN Card"
              value={advisorData?.pan_card_number}
              disabled
            />
          </Grid>
        </Grid>

        <Text className="!font-bold mt-4 mb-2">Bank Details</Text>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <CustomTextInputBasic
              name="accountNumber"
              label="Account Number"
              value={advisorData?.bank_details?.[0]?.bank_account_number}
              disabled
            />
          </Grid>
          <Grid item xs={6}>
            <CustomTextInputBasic
              name="bankName"
              label="Bank Name"
              value={
                Array.isArray(advisorData?.bank_details)
                  ? advisorData.bank_details[0]?.bank_name
                  : ""
              }
              disabled
            />
          </Grid>
          <Grid item xs={6}>
            <CustomTextInputBasic
              name="branch"
              label="Branch"
              value={
                Array.isArray(advisorData?.bank_details)
                  ? advisorData.bank_details[0]?.bank_branch
                  : ""
              }
              disabled
            />
          </Grid>
          <Grid item xs={6}>
            <CustomTextInputBasic
              name="ifscCode"
              label="IFSC Code"
              value={
                Array.isArray(advisorData?.bank_details)
                  ? advisorData.bank_details[0]?.bank_ifsc_code
                  : ""
              }
              disabled
            />
          </Grid>
        </Grid>

        {/* Action Buttons */}
        <div className="flex justify-end mt-4">
          <CustomButton
            type="button"
            variant="default"
            label="Reject"
            onClick={() => setIsReject(true)}
            className="mr-2"
            disabled={isActionDisabled}
          />
          <CustomButton
            type="submit"
            variant="primary"
            label="Approve"
            disabled={isActionDisabled}
            onClick={() => {
              const data = {
                advisor_id: advisorlocalData?.advisor_id,
              };
              advisorApprovalFn(data).then((res) => {
                if (res?.data?.success) {
                  successToast("Advisor Approved successfully");
                  navigate("/advisors");
                }
              });
            }}
          />
        </div>
      </div>

      <div className="flex flex-col p-4 bg-white border border-gray-200 rounded-md mt-4">
        <Text className="!font-bold mb-2">Personal Documents</Text>
        {/* show here 4 document when click on it  */}
        <div className="flex flex-row flex-wrap gap-[1rem]">
          <div className="flex flex-col flex-[0_0_calc(50%_-_0.5rem)]">
            <ShowFileOnUrlWithButton url={advisorData?.front_aadhar_card_image_url} buttonLabel="Front Aadhar Card" documentTitle="Front Aadhar Card" />
          </div>
          <div className="flex flex-col flex-[0_0_calc(50%_-_0.5rem)]">
            <ShowFileOnUrlWithButton url={advisorData?.back_aadhar_card_image_url} buttonLabel="Back Aadhar Card" documentTitle="Back Aadhar Card" />
          </div>
          <div className="flex flex-col flex-[0_0_calc(50%_-_0.5rem)]">
            <ShowFileOnUrlWithButton url={advisorData?.front_pan_card_image_url} buttonLabel="Front PAN Card" documentTitle="Front PAN Card" />
          </div>
          <div className="flex flex-col flex-[0_0_calc(50%_-_0.5rem)]">
            <ShowFileOnUrlWithButton url={advisorData?.back_pan_card_image_url} buttonLabel="Back PAN Card" documentTitle="Back PAN Card" />
          </div>
        </div>
      </div>

      {/* Rejection Remark Section */}
      <div
        className={`flex flex-col p-4 bg-white border border-gray-200 rounded-md mt-4 mb-2 transition-opacity ${isRejectionEnabled ? "opacity-100" : "opacity-50 pointer-events-none"
          }`}
      >
        <Text className="!font-bold mb-2">Rejection Remark</Text>
        <div className="w-1/2">
          <CustomSelectBasic
            name="rejectionRemark"
            label="Reason Type"
            placeholder="Select"
            multiple={true}
            value={reasonType}
            menuList={[
              { label: "Name", value: "name" },
              { label: "Email", value: "email" },
              { label: "Mobile", value: "mobile" },
              { label: "PAN Card", value: "panCard" },
              { label: "Qualification", value: "qualification" },
              { label: "Aadhar Card", value: "adharCard" },
              { label: "Account Number", value: "accountNumber" },
              { label: "Bank Name", value: "bankName" },
              { label: "Branch", value: "branch" },
              { label: "IFSC Code", value: "ifscCode" },




            ]}
            onChange={(e) => setReasonType(e.target.value)}
          />
        </div>

        <div className="mt-2">
          <CustomTextInputBasic
            label="Reason"
            name="reason"
            placeholder="Reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>

        <div className="flex justify-end items-center m-2">
          <CustomButton
            type="button"
            variant="default"
            label="Reset"
            onClick={() => {
              setReasonType([]);
              setReason("");
            }}
            className="m-2"
          />
          <CustomButton
            type="button"
            label="Submit"
            className="m-2"
            onClick={() => {
              const data = {
                advisor_id: advisorlocalData?.advisor_id,
                reason_type: reasonType,
                reason: reason,
              };
              advisorReSubmitFn(data).then((res) => {
                if (res?.data?.success) {
                  successToast("Advisor Rejected successfully");
                  navigate("/advisors");
                }
              });
            }}
          />
        </div>
      </div>

      {/* Resubmission Modal */}
      {isReject && (
        <ResubmissionModal
          open={isReject}
          setOpen={setIsReject}
          setIsRejectionEnabled={setIsRejectionEnabled}
          setIsActionDisabled={setIsActionDisabled}
          id={advisorlocalData?.advisor_id}
          onConfirm={() => {
            setIsRejectionEnabled(true);
            setIsActionDisabled(true);
          }}
        />
      )}
    </div>
  );
};

export default AdvisorDetailPage;
